<div *ngIf="!!accounts?.length" class="mobile_sub_menu">
  <div class="secondary_link" *ngIf="!!selectedAccount" (click)="selectAccount(null)">&lsaquo; Select a different account</div>
</div>
<div class="holder" *ngIf="!!accounts?.length">
  <div class="accounts" [ngClass]="{ selected: selectedAccount }">
    <h5 class="title">ACCOUNTS</h5>
    <photo-toggle-card *ngFor="let account of accounts"
      (click)="selectedAccount?.id === account.id ? null : selectAccount(account)"
      [photoData]="account.photoURL ? { photoURL: account.photoURL } : { title: account.title }"
      [name]="account.title"
      [selected]="selectedAccount?.id === account.id"
    ></photo-toggle-card>
  </div>
  <ng-content></ng-content>
  <div class="wrap920" *ngIf="!selectedAccount">
    <div class="messages">
      {{ unselectedAccountMessage }}
    </div>
  </div>
</div>
<div class="wrap920" *ngIf="!selectedAccount && !!accounts">
  <div class="messages">
    <div *ngIf="true || !accounts?.length">
      You do not have the required permissions to access this feature
    </div>
  </div>
</div>
